export const WHATSAPP_START_URL = "https://wa.me/message/P3WY5EWY7T4EA1";
export const SITE_URL = "https://echomsg.com";
